import { HTTP } from "./common";

export const HistoryApi = {

  list(page) {
    return HTTP.get(`history/?page=${page}&size=20`).then((response) => {
      return response.data;
    });
  },


};


